<header>
	<div class="flex-container row-direction header-content">
		<div class="menu-open" *ngIf="profile">
			<div (click)="openSubItems = !openSubItems">
				<i class="far fa-bars"></i>
			</div>
		</div>

		<div class="logo-container">
			<img class="pwa-logo" src="assets/img/brand/classHeaderLogo.svg"/>
		</div>

		<div class="user-information" *ngIf="profile">
			<div class="notification-content menu-wrap">
				<ng-content></ng-content>
			</div>

			<!-- User info Box -->
			<cv-user-info-header
				[user]="user"
				[toggleUser]="toggleUser"
				[profile]="profile">
			</cv-user-info-header>

			<div class="menu-wrap">
				<button class="btn btn-link mr-1 btn-logout" (click)="logout()">
					<i cvTooltip [tooltipText]="'Sign-out'" [tooltipPlacement]="'bottom'"
					   class="fas fa-sign-out-alt qc-header__right-content__item--market">
					</i>
				</button>
			</div>
		</div>

		<!-- Breadcrumb -->
		<cv-breadcrumb [isPWAMobile]="true"></cv-breadcrumb>
	</div>
	<div class="header-sub-items" *ngIf="openSubItems">
		<ul *ngIf="profile">
			<li>
				<div class="sub-item flex-container" (click)="openUserView()">
					<div class="sub-item-element icon-element">
						<i class="fas fa-user-circle"></i>
					</div>
					<div class="sub-item-element text-element">
						<span *ngIf="user.firstName">
							<span class="full-name">{{ user?.name }}</span>
						</span>
					</div>
					<div class="sub-item-element sub-item-action">
						<i class="fal fa-arrow-right"></i>
					</div>
				</div>
				<div class="sub-item flex-container" (click)="openProfileView()">
					<div class="sub-item-element icon-element">
						<i class="fa-solid fa-gear"></i>
					</div>
					<div class="sub-item-element text-element">
						Settings
					</div>
					<div class="sub-item-element sub-item-action">
						<i class="fal fa-arrow-right"></i>
					</div>
				</div>
			</li>
			<li *ngIf="isSMSEnabled">
				<div class="sub-item flex-container" (click)="openSMSSettingsView()">
					<div class="sub-item-element icon-element">
						<i class="fas fa-cog"></i>
					</div>
					<div class="sub-item-element text-element">
						SMS Settings
					</div>
					<div class="sub-item-element sub-item-action">
						<i class="fal fa-arrow-right"></i>
					</div>
				</div>
			</li>
			<li>
				<div class="sub-item flex-container" (click)="logout()">
					<div class="sub-item-element icon-element">
						<i class="fas fa-sign-out"></i>
					</div>
					<div class="sub-item-element text-element">
						Log Out
					</div>
					<div class="sub-item-element sub-item-action">
						<i class="fal fa-arrow-right"></i>
					</div>
				</div>
			</li>

		</ul>
	</div>
</header>
